module.exports = __webpack_public_path__ + "static/img/actor-not-found_white-2.1c7e8e4.png";